import type { IconName } from "@circleco/compass/components/Icon";
import { IconButton } from "@circleco/compass/components/IconButton";
import { useRef } from "react";
import { useHotkeys } from "react-hotkeys-hook";

interface HeaderIconButtonProps {
  ariaLabel: string;
  counter?: string;
  "data-testid"?: string;
  disabled?: boolean;
  hotkey?: string;
  icon: IconName;
  isOpen?: boolean;
  onClick?: () => void;
}

export const HeaderIconButton = ({
  icon,
  ariaLabel,
  hotkey = "",
  counter,
  isOpen = false,
  disabled = false,
  onClick,
  "data-testid": dataTestId,
}: HeaderIconButtonProps) => {
  const ref = useRef<HTMLButtonElement>(null);

  useHotkeys(
    hotkey,
    () => {
      ref.current?.click();
    },
    { enabled: Boolean(hotkey) },
  );

  return (
    <IconButton
      ref={ref}
      icon={icon}
      variant="ghost"
      size="sm"
      title={ariaLabel}
      aria-label={ariaLabel}
      data-testid={dataTestId}
      data-header-icon-button
      data-popup-open={isOpen || undefined}
      counter={counter}
      disabled={disabled}
      onClick={onClick}
    />
  );
};
